import { useQuery } from "@tanstack/react-query"

import { getBurnRate } from "../../api/ForHire/getBurnRate.ts"
import { getStatusData } from "../../api/ForHire/getStatusData.ts"
import MetricDisplay from "../MetricDisplay.tsx"
import MetricsCard from "../MetricsCard.tsx"

export default function ForHireLiveMetrics() {
  const { data, isPending, isError } = useQuery({
    queryKey: ["forHireStatus"],
    queryFn: getStatusData,
    refetchInterval: 5000,
  })

  const burnRateQuery = useQuery({
    queryKey: ["forHireBurnRate"],
    queryFn: getBurnRate,
    refetchInterval: 1000,
  })

  return (
    <MetricsCard title="Live Metrics">
      <MetricDisplay
        label="Trucks Available"
        value={data ? data.available : 0}
        loading={isPending}
        error={isError}
        unit={data ? `out of ${data.total}` : ""}
      />
      <MetricDisplay
        label="Trucks Dispatched"
        value={data ? data.dispatched + data.inTransit : 0}
        loading={isPending}
        error={isError}
        unit="#"
      />
      <MetricDisplay
        label="Trucks Moving"
        value={data ? data.moving : 0}
        loading={isPending}
        error={isError}
        unit="#"
      />
      <MetricDisplay
        label="Fuel Burn Rate"
        value={burnRateQuery.data || 0}
        loading={burnRateQuery.isPending}
        error={burnRateQuery.isError}
        unit="MMBtu / Day"
      />
    </MetricsCard>
  )
}
